
import {Component, Prop, Vue} from "vue-property-decorator";
import OkDialog from "@/components/common/OkDialog.vue";
import ReadonlyDataField from "@/models/ReadonlyDataField";

@Component({
  name: 'CheckBoxFieldReadonly',
  components: {
    OkDialog
  },
})
export default class CheckBoxFieldReadonly extends Vue {

  @Prop({required: true})
  private dataField: ReadonlyDataField

  get isVisible() {
    return this.field.isVisible;
  }

  get isReadonly() {
    return true;
  }

  get field() {
    return this.dataField;
  }

  get value() {
    return this.dataField?.values?.value;
  }

  get canBeUnknown() {
    return this.field.definition.canBeUnknown ?? false;
  }

  get unknown() {
    return this.dataField.values.unknown;
  }

  get displayName() {
    if (!this.dataField.displayName)
      return ""
    return this.dataField.displayName;
  }
}
